export default "__VITE_ASSET__BAgDPBpE__"